import inRange from 'lodash/inRange';
import { DateTime } from 'luxon';

export const isValidDayInput = (dayValueArg: string) => {
  if (dayValueArg === '00') {
    return false;
  }

  return !dayValueArg || inRange(Number(dayValueArg), 0, 32);
};

export const isValidMonthInput = (monthValueArg: string) => {
  if (monthValueArg === '00') {
    return false;
  }

  return !monthValueArg || inRange(Number(monthValueArg), 0, 13);
};

export const isValidYearInput = (yearValueArg: string) =>
  !yearValueArg || inRange(Number(yearValueArg), 1, DateTime.utc().year + 1);

export const getInitialDateValues = (date: Date | null) => {
  if (date && DateTime.fromJSDate(date).isValid) {
    return {
      month: (date.getUTCMonth() + 1).toString(),
      day: date.getUTCDate().toString(),
      year: date.getUTCFullYear().toString(),
    };
  }

  return {
    month: '',
    day: '',
    year: '',
  };
};
